import { render, staticRenderFns } from "./TotalClicks.vue?vue&type=template&id=33d20bda&scoped=true"
import script from "./TotalClicks.vue?vue&type=script&lang=js"
export * from "./TotalClicks.vue?vue&type=script&lang=js"
import style0 from "./TotalClicks.vue?vue&type=style&index=0&id=33d20bda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d20bda",
  null
  
)

export default component.exports